import React, { Component } from 'react';
import {
  Row,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  Table,
  Card, CardBody
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import Button from '../../../shared/components/Button';
import PhonePreview from '../../../shared/components/PhonePreview';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';

import {
  timeForEngagements,
  formatDateRange,
  formatPaymentMethod,
  getPreviewLinkForCampaignWithPreviewId ,
  humanReadableList,
  toTitleCase,
  geoFilterSort,
  constraintDisplayName
} from '../../../shared/utils';

import find from 'lodash/find';
import moment from "moment";
import capitalize from "lodash/capitalize";

const NATIONWIDE_STATECODE = '__NATION_WIDE__';

class AdjoyApproveCampaign extends Component {
  constructor(props){
    super(props);

    this.state = {
      activeEngagementId: '__FEED__',
      validationMessages:{},
      showRejectReason:false,
      hasViewedEngagements:false,
      isLoading:false,
      showQAAnswer:false
    };
  }

  componentDidMount(){
    this.setState({isLoading:true});

    const loadEntityPromises = [
      this.props.loadCampaignHistory(this.props.campaignId),
      this.props.loadCampaign(this.props.campaignId),
      this.props.loadEngagementsForCampaign(this.props.campaignId),
      this.props.loadPublishersForCampaign(this.props.campaignId),
      this.props.loadCampaignReach(this.props.campaignId),
      this.props.loadRetailers(),
      this.props.loadListOfStatesAndDMAs()
    ];

    if(this.props.campaign.companyId){
      loadEntityPromises.push(this.props.loadBrand(this.props.campaign.companyId));
    }
    if(this.props.campaign.agencyId){
      loadEntityPromises.push(this.props.loadAgency(this.props.campaign.agencyId));
    }

    if(this.props.campaign.paymentMethodId && this.props.campaign.agencyId){
      loadEntityPromises.push(this.props.loadPaymentMethodsForAgency(this.props.campaign.agencyId))
    }

    Promise
      .all(loadEntityPromises)
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  handleSubmitClick(){
    this.props.adjoyApproveCampaign(this.props.campaignId)
      .then(() => this.setState({done:true}))
      .then(() => this.props.showNotification('success','Experience approved and will start when start date is reached.'))
      .catch((err) => this.setState({error:err}));
  }

  handleRejectionSubmit(data){
    const {
      campaignId,
      showNotification,
      adjoyRejectCampaign
    } = this.props

    const validationMessages = {};

    const { reason } = data;

    if(!reason || reason.length === 0){
      validationMessages['reason'] = 'Please provide feedback before continuing';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      adjoyRejectCampaign(campaignId,reason)
        .then(() => showNotification('success','Feedback sent to team. Experience now in Draft and ready for edits'))
        .catch((err) => this.setState({error:err}));
    }

  }

  handleBackClick(){
    const engagementIds = this.props.engagements.map((e) => e.id),
      activeId = this.state.activeEngagementId,
      activeIdIndex = engagementIds.indexOf(activeId),
      activeEngagement = find(this.props.engagements, (e) => e.id === activeId),
      lastId = engagementIds[engagementIds.length - 1],
      previousId = engagementIds[activeIdIndex - 1],
      previousEngagement = find(this.props.engagements, (e) => e.id === previousId),
      showQAAnswer = this.state.showQAAnswer;

    if(activeEngagement && activeEngagement.kind === 'qa' && showQAAnswer){
      this.setState({
        showQAAnswer:false,
        activeEngagementId:activeId
      });

    } else if(previousEngagement && previousEngagement.kind === 'qa' && !showQAAnswer){
      this.setState({
        showQAAnswer:true,
        activeEngagementId:previousId
      });

    } else if(activeId === '__CONCLUSION__'){
      this.setState({
        activeEngagementId:lastId
      });

    } else if(activeIdIndex - 1 >= 0){
      this.setState({
        activeEngagementId:previousId
      });

    } else if(activeIdIndex === 0){
      this.setState({
        activeEngagementId:'__FEED__'
      });

    }
  }

  handleNextClick(){
    const engagementIds = this.props.engagements.map((e) => e.id),
      activeId = this.state.activeEngagementId,
      activeIdIndex = engagementIds.indexOf(activeId),
      activeEngagement = find(this.props.engagements, (e) => e.id === activeId),
      firstId = engagementIds[0],
      nextId = engagementIds[activeIdIndex + 1],
      nextEngagement = find(this.props.engagements, (e) => e.id === nextId),
      showQAAnswer = this.state.showQAAnswer;

    if(activeEngagement && activeEngagement.kind === 'qa' && !showQAAnswer){
      this.setState({
        showQAAnswer:true,
        activeEngagementId:activeId
      });

    } else if(nextEngagement && nextEngagement.kind === 'qa' && showQAAnswer){
      this.setState({
        showQAAnswer:false,
        activeEngagementId:nextId
      });

    } else if(activeId === '__FEED__'){
      this.setState({
        activeEngagementId:firstId
      });

    } else if(activeIdIndex >= 0 && activeIdIndex + 1 < engagementIds.length){
      this.setState({
        activeEngagementId:nextId
      });

    } else if(activeIdIndex + 1 === engagementIds.length){
      this.setState({
        activeEngagementId:'__CONCLUSION__',
        hasViewedEngagements:true
      });
    }
  }

  handleCopyLinkClick(){
    this.linkInput.select();
    document.execCommand('copy');
  }


  getReachForCampaign(campaign){
    if(campaign.costPerCompletion === 0){
      return 0;
    }

    return Math.floor((campaign.lifetimeBudget || 0) / campaign.costPerCompletion)
  }

  getFormattedReach(){
    const {
      possibleStates,
      campaign
    } = this.props;

    const { isLoading } = this.state;

    if(campaign.costPerCompletion === 0){
      return 0;
    }

    const priceReach = Math.floor((campaign.lifetimeBudget || 0) / campaign.costPerCompletion);

    if(isLoading){
      return (<i>Loading</i>)
    } else {
      const audienceReach = campaign.reach,
        reach = Math.min(audienceReach,priceReach);

      return (<span>{(reach || 0).toLocaleString()} consumers</span>);
    }
  }

  getFormattedAudience(){
    const {campaign,possibleGeoFilters} = this.props;

    const matchingFilterNames = (campaign.filters || [])
      .map((f) => possibleGeoFilters.find((g) => g.code === f.code))
      .filter((f) => !!f)
      .sort((a,b) => geoFilterSort(a,b))
      .map((f) => toTitleCase(f.name.toLowerCase()));


    if(campaign.geoFilterPredicate && possibleGeoFilters.length === 0){
      return 'Loading...'
    } else if(campaign.geoFilterPredicate === 'include'){
      return humanReadableList(matchingFilterNames);
    } else if(campaign.geoFilterPredicate === 'exclude'){
      return `Nationwide excluding ${matchingFilterNames}`;
    } else if(campaign.geoFilterPredicate === 'zip'){
      return 'Custom';
    } else {
      return 'Nationwide';
    }
  }

  getTotalExposureTimeForCampaignWithEngagements(campaign,engagements){
    const seconds = this.getReachForCampaign(campaign) * timeForEngagements(engagements);

    return Math.floor(seconds / (60 * 60))
  }

  getFormattedPaymentMethod(){
    if(this.state.isLoading) return (<i>Loading</i>);

    if(this.props.paymentMethodId){
      if(this.props.paymentMethod.id){
        return formatPaymentMethod(this.props.paymentMethod);
      } else {
        return 'Default Credit Card';
      }
    }

    return 'Account Funds';
  }

  getFormattedPublishers(){
    const {
      campaign,
      retailers
    } = this.props;

    const { isLoading } = this.state;

    if(isLoading){
      return (<i>Loading</i>)
    } else if(!campaign.publisherIds || campaign.publisherIds.length === 0){
      return (<i>None</i>)
    } else if(campaign.publisherIds.length === retailers.length){
      return (<span>Nationwide Dabbl Network</span>)
    } else {
      let selectedPublisherNames = retailers.filter((r) => campaign.publisherIds.indexOf(r.id) >= 0).map((r) => r.name);

      return (<span>{humanReadableList(selectedPublisherNames)}</span>)
    }
  }


  getResponseTargeting(){
    const {
      campaign
    } = this.props;

    const { isLoading } = this.state;

    return constraintDisplayName(campaign);
  }

  getFormattedHistoryAction(action){
    if(action === 'suspended'){
      return 'Paused';
    } else if(action === 'approved'){
      return 'Admin Approved';
    } else if(action === 'adjoyApproved'){
      return 'Dabbl Approved';
    } else if(action === 'submittedAndApproved'){
      return 'Submitted';
    } else if(action === 'adjoyRejected' || action === 'rejected'){
      return 'Changes Needed';
    } else if(action === 'activated'){
      return 'Activated';
    } else if(action === 'duplicated'){
      return 'Created';
    } else if(action === 'fundsRequested'){
      return 'Threshold Reached';
    } else if(action === 'revertedToDraft'){
      return 'Edited';
    } else if(action === 'archived'){
      return 'Archived';
    } else {
      return capitalize(action);
    }
  }

  render(){
    const {
      activeEngagementId,
      showRejectReason,
      hasViewedEngagements,
      validationMessages,
      isLoading,
      showQAAnswer
    } = this.state;

    const {
      campaign,
      engagements,
      brand,
      paymentMethod,
      publishers,
      agencyName
    } = this.props;

    const approvalNeeded = campaign.status === 'pendingAdjoy',
      userGets  = campaign.valuePerUser || 0,
      adjoyGets = campaign.costPerCompletion - userGets;

    const previewUri = `${window.location.protocol}//${window.location.hostname+(window.location.port ? ':'+window.location.port: '')}/preview/${campaign.previewToken}`

    return (
      <div>
        <Row>
          <Col xs='8'>
            <Table>
              <colgroup>
                <col style={{width:'40%'}} />
                <col style={{width:'60%'}} />
              </colgroup>
              <tbody>
                <tr>
                  <th>Account</th>
                  <td>{agencyName}</td>
                </tr>
                <tr>
                  <th>Launch Date</th>
                  <td>{formatDateRange(campaign.launchDate,campaign.endDate)}</td>
                </tr>
                <tr>
                  <th>Budget</th>
                  <td>
                    <MoneyDisplay>{campaign.lifetimeBudget || 0}</MoneyDisplay>
                  </td>
                </tr>
                <tr>
                  <th>Cost per Completion</th>
                  <td>
                    <MoneyDisplay>{campaign.costPerCompletion}</MoneyDisplay>&nbsp;&nbsp;
                    (Dabbl: <MoneyDisplay>{adjoyGets}</MoneyDisplay>,&nbsp;
                    User: <MoneyDisplay>{userGets}</MoneyDisplay>)
                  </td>
                </tr>
                <tr>
                  <th>Priority</th>
                  <td>{campaign.priority === 9 ? 'Default' : campaign.priority}</td>
                </tr>
                <tr>
                  <th>Estimated Experience Duration</th>
                  <td>{timeForEngagements(engagements)} seconds</td>
                </tr>
                <tr>
                  <th>Estimated Reach</th>
                  <td>{this.getFormattedReach()}</td>
                </tr>
                <tr>
                  <th>Payment Method</th>
                  <td>{this.getFormattedPaymentMethod()}</td>
                </tr>
                <tr>
                  <th>Preview Link</th>
                  <td>
                    <TextInput
                      value={previewUri}
                      readOnly
                      copyPaste
                    />
                  </td>
                </tr>
                <tr>
                  <th>Location</th>
                  <td>{this.getFormattedAudience()}</td>
                </tr>
                <tr>
                  <th>Response Targeting</th>
                  <td>{this.getResponseTargeting()}</td>
                </tr>
                <tr>
                  <th>Publishers</th>
                  <td>
                    {this.getFormattedPublishers()}
                    &nbsp;&nbsp;
                    <Link className='pull-right' to={`/superadmin/experiences/${campaign.id}/publishers`}>Edit</Link>
                  </td>
                </tr>
              </tbody>
            </Table>
            <br />
            {!approvalNeeded && (
                <Card className='DataCard'>
                  <CardBody>
                    <strong>Activity History</strong>
                    <br />
                    <br />
                    {campaign.history ? (
                        <div>
                          {campaign.history.length > 0 ? (
                              <div>
                                {campaign.history.map((e) => (
                                    <Row key={`${e.action}_${e.timestamp}`}>
                                      <Col xs='6'>
                                        {this.getFormattedHistoryAction(e.action)}
                                      </Col>
                                      <Col xs='6'>
                                        <div className='data'>
                                          {moment(e.timestamp).format('MMM D, YYYY, h:mm:ss a')}
                                        </div>
                                      </Col>
                                    </Row>
                                ))}
                              </div>
                          ) : (
                              <div>None available</div>
                          )}
                        </div>
                    ) : (
                        <div>Loading...</div>
                    )}
                  </CardBody>
                </Card>
            )}
            {approvalNeeded && (
              <div className='clearfix'>
                <Button
                  onClick={() => this.handleSubmitClick()}
                  disabled={showRejectReason || !hasViewedEngagements}
                >
                  Approve
                </Button>
                <Button
                  className='pull-right'
                  backgroundColor='transparent'
                  textColor='#666666'
                  borderColor='#cccccc'
                  onClick={() => this.setState({showRejectReason:true})}
                  disabled={showRejectReason || !hasViewedEngagements}
                >
                  Changes Needed
                </Button>
              </div>
            )}
            {approvalNeeded && showRejectReason && (
              <Form onSubmit={(data) => this.handleRejectionSubmit(data)}>
                <br />
                <br />
                <TextInput
                  label='Feedback'
                  name='reason'
                  multiline
                  placeholder='Describe changes required for experience to be approved.'
                  maxLength={1000}
                  warning={validationMessages['reason']}
                />
                <div className='clearfix'>
                  <Button
                    isSubmit
                  >
                    Send Feedback
                  </Button>
                  <Button
                    className='pull-right'
                    backgroundColor='transparent'
                    textColor='#666666'
                    borderColor='#cccccc'
                    onClick={() => this.setState({showRejectReason:false})}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            )}
            <br />
          </Col>
          <Col xs={{size:3,offset:1}}>
            {activeEngagementId && engagements && engagements.length > 0 && (
              <div>
                <PhonePreview
                  hideTotalValue
                  phonePlatform='generic'
                  height={400}
                  align='left'
                  activeEngagementId={activeEngagementId}
                  engagements={engagements}
                  brandName={brand.name}
                  feedImageURL={campaign.feedImageURL || require('../../../shared/assets/fpo-tile.png')}
                  feedText={campaign.feedText || ''}
                  valuePerUser={campaign.valuePerUser || 0}
                  conclusionText={campaign.completionText}
                  logoURL={brand.logoURL}
                  conclusionBackgroundColor={brand.primaryColor}
                  completionImageURL={campaign.completionImageURL}
                  showQAAnswer={showQAAnswer}
                  cta={campaign.useCTA ? {link: campaign.ctaLink, color: campaign.ctaColor, text: campaign.ctaText} : null}
                />
                <br />
                <div className='clearfix'>
                  <Button
                    className='pull-left'
                    size='sm'
                    textColor='#666666'
                    borderColor='#cccccc'
                    backgroundColor='#ededed'
                    onClick={() => this.handleBackClick()}
                    disabled={activeEngagementId === '__FEED__'}
                  >
                    Back
                  </Button>
                  <Button
                    className='pull-right'
                    size='sm'
                    textColor='#666666'
                    borderColor='#cccccc'
                    backgroundColor='#ededed'
                    onClick={() => this.handleNextClick()}
                    disabled={activeEngagementId === '__CONCLUSION__'}
                  >
                    Next
                  </Button>
                </div>
                <br />
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default AdjoyApproveCampaign;



// WEBPACK FOOTER //
// ./src/routes/AdjoyApproveCampaign/components/AdjoyApproveCampaign.js